import styled, { css } from 'styled-components';
import { isMobile, isTablet } from 'react-device-detect';
import theme from 'shared/assets/style/theme';
import Animated from 'animated/lib/targets/react-dom';
import { isNotStandaloneMobilePWA, isStandalonePWA } from '../../../utils/mobileSupported';

const windowWidth = window.innerWidth;
const windowHeight = window.innerHeight;

export const PageContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url(${props => props.background});
  background-size: 100% 100%;
`;

export const HiddenContentWrapper = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  pointer-events: ${({ hide }) => (hide ? 'none' : 'auto')};
`;

export const WheelSlice = styled(Animated.div)`
  position: absolute;
  left: 0px;
  right: 0px;
  height: 50px;
  transform: rotate(${({ rowindex }) => (360 / 16) * rowindex}deg);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

export const WheelSliceContainer = styled.div`
  width: 23%;
  display: flex;
  align-items: center;
  justify-content: left;
`;

export const SliceCurrencyIcon = styled.img`
  height: 30px;
  width: 30px;
  object-fit: contain;
`;

export const SliceTextWrapper = styled.span`
  margin-left: ${({ outstanding }) => (outstanding ? 20 : 0)}px;
  ${({ theme }) => theme}
`;

export const SkipButton = styled(Animated.div)`
  position: absolute;
  right: 16px;
  height: 57px;
  width: 88px;
  pointer-events: all;
`;

export const WheelButtonLogo = styled.img`
  width: 16vh;
  height: 16vh;
  position: absolute;
  z-index: 1;
`;

export const TickerContaner = styled.div`
  position: absolute;
  top: 40%;
  right: -15%;
  height: 20%;
  width: 20%;
  background-color: transparent;
  border-radius: 50%;
`;

const StreakColumnContainerMobilePadding = css`
  padding: 0px;
  width: ${isTablet ? '33%' : windowHeight < 380 ? '25%' : '28%'};
`;

export const StreakColumnContainer = styled(Animated.div)`
  flex: 1;
  width: ${props => props.width + props.unit};
  padding: ${({ hero }) =>
    hero && windowHeight < 800
      ? 0
      : windowHeight > 920 && windowWidth < 1300
        ? '4.2vw 0'
        : windowHeight > 1020
          ? '3.2vw 0'
          : '1.2vw 0'};
  box-sizing: border-box;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 580px;
  ${isMobile && StreakColumnContainerMobilePadding}
`;

const StreakColumnContentWrapperTabletPWA = css`
  height: ${isStandalonePWA ? 80 : 90}%;
  ${({ theme }) => theme}
`;

export const StreakColumnContentWrapper = styled.div`
  width: 80%;
  height: ${windowHeight < 380 ? '100%' : '98%'};
  display: flex;
  flex-direction: column;
  position: relative;

  @media only screen and (max-height: 780px) {
    padding: ${windowHeight < 380 ? '0.1vw 0' : '0.5vw 0'};
  }

  @media only screen and (min-width: 2200px) {
    width: 550px;
    height: 900px;
  }
  ${isTablet && StreakColumnContentWrapperTabletPWA}
  ${({ theme }) => theme}
`;

export const StreakColumnInfoIcon = styled.img`
  width: 70px;
  height: 70px;
  object-fit: contain;
  position: absolute;
  top: 0px;
  right: -50px;
  cursor: pointer;
`;

export const StreakColumnBackground = styled.img`
  width: 100%;
  height: 100%;
  object-fit: fill;
  position: absolute;
  top: 0;
  left: 0;
`;

export const StreakColumnHolder = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
`;

export const StreakHeaderTextWrapper = styled.div`
  position: relative;
  top: -4px;
  font-size: 0.8rem;
  color: ${theme.palette.common[1]};
`;

export const MilestoneRow = styled.div`
  position: absolute;
  top: ${({ hero }) =>
    hero
      ? windowHeight < 980
        ? windowWidth < 1400
          ? '9.5%'
          : '10.5%'
        : '13.5%'
      : windowHeight < 800
        ? '17%'
        : windowHeight < 1000
          ? '19%'
          : '21%'};
  width: 142%;
  height: ${({ hero }) => (hero ? 210 : 170)}px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  z-index: 3;

  @media only screen and (min-width: 1900px) and (min-height: 1050px) {
    height: ${({ hero }) => (hero ? 250 : 190)}px;
    top: ${({ hero }) => (hero ? '9.5%' : '18.5%')};
  }

  @media only screen and (min-width: 2200px) and (min-height: 1200px) {
    height: ${({ hero }) => (hero ? 250 : 190)}px;
    top: ${({ hero }) => (hero ? '10.5%' : '19.5%')};
  }
`;

export const MilestoneBackground = styled.img`
  width: 100%;
  height: 100%;
  object-fit: fill;
  position: absolute;
  top: 0;
  left: -3px;
`;

export const MilestoneRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100px;
  justify-content: space-between;
  align-items: center;
  padding: 0px 50px;
  z-index: 2;
  ${({ theme }) => theme}
`;

export const MilestonePrizeItemWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  line-height: 1;
`;

export const MilestonePrizeTextHolder = styled.div`
  text-align: center;
  margin-left: 0.5rem;
  font-size: 2.1rem;
  font-weight: 700;
  margin-top: ${({ center }) => (center ? 0 : 0)}rem;

  @media screen and (min-height: 970px) {
    margin-top: ${({ center }) => (center ? 1 : 0)}rem;
  }

  ${({ theme }) => theme}
`;

export const MilestonePlusText = styled(MilestonePrizeTextHolder)`
  margin-right: 0.5rem;
  margin-left: 0px;
`;

export const MilestoneCircleText = styled.div`
  font-size: ${({ length }) =>
    windowHeight < 800 ? (length < 3 ? '1.7rem' : '1.2rem') : length < 3 ? '2rem' : '1.5rem'};
  font-weight: 700;
  ${({ theme }) => theme}
`;

export const StreakColumnHolderSpace = styled.div`
  display: flex;
  flex: 0.5;
`;

const SmallDeviceDayStreakContainer = css`
  padding: 0rem 1rem;
  margin: 0px 1rem;
  max-height: ${windowHeight > 350 ? 350 : windowHeight > 330 ? 330 : windowHeight > 310 ? 310 : 280}px;
  overflow-y: scroll;
  scroll-behavior: smooth;
  overflow-x: hidden;
  box-sizing: border-box;
  justify-content: unset;
  touch-action: pan-y;
  margin-bottom: ${windowHeight > 350 ? 1 : 0}rem;
  -webkit-overflow-scrolling: touch;
  ${({ smallScreenTheme }) => smallScreenTheme}
`;

const TabletPWADayStreakContainer = css`
  padding: ${windowWidth > 1150 ? '2rem 1rem 0.5rem 1rem' : '1rem 1rem'};
  margin: ${windowWidth > 1150 ? '0 1rem' : '1rem 1rem'};
`;

export const DaysStreakContainer = styled.div`
  flex: 1;
  align-self: stretch;
  margin: 0px 24px;
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-evenly;
  ${isNotStandaloneMobilePWA && SmallDeviceDayStreakContainer}
  ${isStandalonePWA && isTablet && TabletPWADayStreakContainer}
`;

export const RegDaysRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: ${windowHeight < 750 ? '35px' : 'auto'};
`;

export const RegDaysLightImageLeft = styled.img`
  height: 30px;
  width: 30px;
  position: absolute;
  left: -20px;
`;

export const RegDaysLightImageRight = styled(RegDaysLightImageLeft)`
  right: -20px;
  left: auto;
`;

export const RegDaysStreakDayText = styled.div`
  color: ${theme.palette.common[1]};
  width: 55px;
  text-align: center;
  font-size: ${({ length }) => (length === 1 ? 1.4 : length === 2 ? 1.1 : 1)}rem;
  font-weight: 600;
  padding: 0px 2px;
  ${({ theme }) => theme}
`;

export const RegDaysDayText = styled(RegDaysStreakDayText)`
  font-size: 1.3rem;
  opacity: ${props => props.opacity};
  padding: 0px ${({ day }) => (day > 99 ? '8px' : '2px')};
`;

export const RegDayRowContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  z-index: 1;
`;

export const RegDaysItemWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const RegDaysItemText = styled.div`
  opacity: ${props => props.opacity};
  color: ${theme.palette.common[1]};
  text-align: center;
  margin-left: 2px;
  font-size: ${windowWidth > 1530 ? 1.6 : 1.4}rem;
  font-weight: 600;
  ${({ theme }) => theme}
`;

export const RegDaysItemWrapperInnerIcon = styled.div`
  flex: ${({ flex }) => flex || 1};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: ${({ paddingright }) => paddingright || 0}px;
`;

export const RegDaysItemWrapperInnerText = styled.div`
  flex: ${({ flex }) => flex || 2};
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const RegDaysItemWrapperCenter = styled(RegDaysItemWrapper)`
  justify-content: center;
  flex: 0.3;
  color: ${theme.palette.common[1]};
  font-size: 1.5rem;
  font-weight: 600;
  opacity: ${props => props.opacity};
`;

export const EmptyDivSpace = styled.div`
  flex: ${props => props.flex};
`;

export const RegDaysItemWrapperRight = styled(RegDaysItemWrapper)`
  justify-content: flex-end;
`;

export const RegDaysItemCoinIcon = styled.img`
  height: 28px;
  width: 28px;
  opacity: ${props => props.opacity};
  object-fit: contain;
`;

export const BottomBarContainer = styled(Animated.div)`
  ${({ theme }) => theme}
`;

export const BottomBarBackgroundWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  object-fit: fill;
`;

export const BottomBarBackgroundWrapperImage = styled.img`
  ${({ theme }) => theme}
  position: absolute;
  bottom: 0px;
  left: 0px;
  pointer-events: none;
`;

export const BottomLeftPartIcon = styled.img`
  height: 55%;
  object-fit: contain;
  filter: drop-shadow(2px 2px 4px ${theme.palette.common[26]});
`;

export const BottomBarPlusText = styled.span`
  font-size: 2rem;
  font-weight: 400;
  text-shadow: 2px 2px 4px ${theme.palette.common[26]};
  z-index: 1;
  ${isTablet && isNotStandaloneMobilePWA && 'margin-bottom: 4vh;'}
`;

const BottomRightSideMobile = css`
  bottom: ${isNotStandaloneMobilePWA ? 1.2 : 0.7}rem;
  width: ${isNotStandaloneMobilePWA && isTablet ? 55 : 50}%;
`;

export const BottomRightSideContainer = styled.div`
  position: relative;
  align-self: flex-start;
  width: 60%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${isMobile && BottomRightSideMobile}
`;

export const BottomRightContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;

export const BottomTotalBonusWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
  width: 100%;
`;

export const BottomTotalBonusImage = styled.img`
  margin-left: 14px;
  height: ${windowWidth < 1400 ? 25 : 30}px;
  object-fit: contain;
  object-position: 0%;
`;

export const BottomRightCoinImage = styled.img`
  height: ${windowHeight < 900 ? 30 : 40}px;
  width: ${windowHeight < 900 ? 30 : 40}px;
  object-fit: contain;
  ${({ theme }) => theme}
`;

export const BottomRightItemsText = styled.div`
  text-align: center;
  margin-left: ${({ left }) => left || '5px'};
  font-size: 1.8rem;
  font-weight: 600;
`;

export const BottomBarRightPlusText = styled.div`
  color: ${theme.palette.common[1]};
  font-size: 34px;
  margin-left: 20px;
  margin-right: 15px;
`;

export const BottomRightLoyaltyImage = styled(BottomRightCoinImage)`
  height: 50px;
  width: 50px;
`;

export const BottomBarRightSideBottomText = styled.img`
  width: 85%;
  max-width: 600px;
  align-self: flex-end;
  ${({ theme }) => theme}
`;

/**
 * Onboarding
 */

export const OnboardingContainer = styled.div`
  cursor: pointer;
`;

const smallScrennOnboardingImage = css`
  width: 80%;
  height: 80%;
  margin-left: 10%;
  margin-top: -3rem;
`;

export const OnboardingImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 1em;
  ${isNotStandaloneMobilePWA && smallScrennOnboardingImage}
`;

export const Styles = {
  wheelSliceContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
  },
  wheelSliceContainerInner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  wheelFrameAndTicker: {
    position: 'absolute',
    height: '100%',
    width: '100%',
  },
  spinButtonWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    objectFit: 'contain',
  },
  spinButtonWrapperInner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  skipButton: {
    position: 'absolute',
    right: isNotStandaloneMobilePWA ? 60 : 16,
    height: 57,
    width: 88,
    pointerEvents: 'all',
    objectFit: 'contain',
    margin: 0,
  },
  skipButtonImage: {
    width: 88,
  },
};

export const StreakColumnStyles = {
  prizeTopper: {
    height: 45,
    zIndex: 1,
  },
  prizeTopperManual: {
    top: -20,
    left: -20,
    right: -20,
    bottom: -40,
  },
  prizeRowHolder: {
    flex: 1,
  },
  prizeRowHolderInner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  milestoneRibbon: {
    height: '86%',
    alignSelf: 'stretch',
    zIndex: 1,
  },
  milestoneRibbonInner: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  milestonePlusText: {
    fontSize: 32,
  },
  milestoneCircleImageCenterLayout: {
    top: windowHeight > 1000 ? '-2.5vh' : '-3.5vh',
    height: windowHeight < 800 ? 48 : 52,
  },
  milestoneCircleImageInner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    top: -15,
  },
  milestoneCircleDayText: {
    fontSize: 20,
  },
  daysStreakContainer: {
    flex: 1,
    alignSelf: 'stretch',
    margin: '0px 24px',
    display: 'flex',
    flexDirection: 'column-reverse',
    justifyContent: 'space-evenly',
  },
  daysStreakContainerInner: {
    display: 'flex',
    flexDirection: 'column-reverse',
    justifyContent: 'space-evenly',
    alignItems: 'stretch',
  },
  streakDayRowIndicator: {
    height: isTablet && isStandalonePWA ? 25 : 30,
    width: isTablet && isStandalonePWA ? 27 : windowWidth < 1300 ? 32 : 34,
    objectFit: 'fill',
    marginLeft: isTablet && isStandalonePWA ? 14 : windowWidth > 1540 ? 12 : 8,
    marginRight: isTablet && isStandalonePWA ? 14 : 10,
    zIndex: 2,
  },
  streakDayRowIndicatorBigNumber: {
    height: windowWidth < 1400 ? 32 : 35,
    width: windowWidth < 1400 ? 35 : 38,
    objectFit: 'fill',
    marginLeft: 10,
    marginRight: windowWidth < 1400 ? 12 : 5,
    zIndex: 2,
  },
  streakDayRowIndicatorInner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  rowDivider: {
    width: '100%',
    height: 3,
    zIndex: 10,
  },
};

export const BottomBarStyles = {
  bottomBarImageWrapper: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    objectFit: 'fill',
  },
  bottomBarImageWrapperInner: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
  },
  bottomRightWrapper: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    top: 10,
    height: '65%',
    width: '95%',
    objectFit: 'fill',
    inset: 'auto',
  },
  bottomRightWrapperInner: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0.5rem 0',
  },
  bottomCollectButton: {
    objectFit: 'contain',
    cursor: 'pointer',
    pointerEvents: 'all',
    width: '35%',
  },
  bottomCollectButtonContainer: {
    width: '35%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '10%',
    marginBottom: 4,
  },
  comingSoonCardtext: {
    textTransform: 'uppercase',
  },
};

